import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Generated with generate-feature-flag-custom-hook.sh script
 * on 2025-11-11T11:00:00-0700.
 */
export function useCurrencyExpansionEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.SpaceOpsCurrencyExpansion,
    false
  );

  return Boolean(isEnabled);
}

